import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-0e0de11a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "login-container" }
const _hoisted_2 = { class: "logo-container" }
const _hoisted_3 = {
  key: 0,
  class: "login-form-container"
}
const _hoisted_4 = {
  key: 1,
  class: "login-form-container"
}

import { useRoute, useRouter } from "vue-router";
import { onMounted, onUnmounted } from "vue";
import { useAuthStore } from "@/store/auth/login";

import DvLogoComponent from "@/shared/auth/DvLogoComponent.vue";
import PasswordRecoveryForm from "@/shared/auth/PasswordRecoveryForm.vue";
import NewPasswordForm from "@/shared/auth/NewPasswordForm.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'RecoveryPasswordPage',
  setup(__props) {

const route = useRoute();
const router = useRouter();
const authStore = useAuthStore();

const handlePasswordRecovered = () => {
  localStorage.setItem("isPasswordRecovered", "true");
  authStore.setPasswordRecovered(true);
};

const handleStorageChange = (event: any) => {
  if (event.key === "isPasswordRecovered" && event.newValue === "true") {
    goToLK();
    localStorage.removeItem("isPasswordRecovered");
  }
};

const goToLK = () => {
  if (route.query && !route.query.nonce)
    router.push({ name: "personalAccount" });
};

onMounted(() => {
  window.addEventListener("storage", handleStorageChange);
});

onUnmounted(() => {
  window.removeEventListener("storage", handleStorageChange);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(DvLogoComponent)
    ]),
    (_unref(route).query && _unref(route).query.nonce)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(NewPasswordForm, { onGoToLK: handlePasswordRecovered })
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createVNode(PasswordRecoveryForm)
        ]))
  ]))
}
}

})